import React from "react";

const Balance = props => {
  return (
    <div
      style={{
        fontSize: "18px",
        fontWeight: "bold",
        color: "green",
        padding: "20px"
      }}
    >
      Your Balance: ${props.amount}
    </div>
  );
};

export default Balance;
